import { c as _c } from "react/compiler-runtime";
import React, { JSX } from 'react';
const Divider = t0 => {
  const $ = _c(8);
  let props;
  let style;
  if ($[0] !== t0) {
    ({
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = style;
  } else {
    props = $[1];
    style = $[2];
  }
  let t1;
  if ($[3] !== style) {
    t1 = {
      borderBottom: "2px solid #ddd",
      ...style
    };
    $[3] = style;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div {...props} style={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default Divider;